import { GetServicesRefundInfoQuery } from '@websky/graphql';

export type GdsServicesRefundInfo = GetServicesRefundInfoQuery['GetGdsServicesRefundInfo']['gdsServicesRefundInfo'];

export const getRefundableGdsServices = (services: GdsServicesRefundInfo = []): GdsServicesRefundInfo => {
	return services
		.map(serviceInfo => {
			if (!serviceInfo) {
				return null;
			}

			const refundableProducts = serviceInfo.gdsServiceProductsRefundInfo.filter(
				productInfo => productInfo?.refundable === true
			);

			if (!refundableProducts.length) {
				return null;
			}

			return {
				...serviceInfo,
				gdsServiceProductsRefundInfo: refundableProducts
			};
		})
		.filter(Boolean) as GdsServicesRefundInfo;
};
